"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _commonReact = require("@devsta/common-react");

var _uiKit = require("@devsta/ui-kit");

require("./_social-iteration.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var ASPECT_RATIO_ROTATE_MAP = {
  WIDE: {
    rotated: true
  },
  SQUARE: {
    rotated: true
  },
  INSTA: {
    rotated: false
  },
  STANDARD: {
    rotated: true
  }
};

function handleOutputNotesChange(onNotesChange, outputId) {
  return function (event) {
    onNotesChange(outputId, event.target.value);
  };
}

function SocialIteration(_ref) {
  var aspectRatio = _ref.aspectRatio,
      onChangeAddon = _ref.onChangeAddon,
      canUpdateOutput = _ref.canUpdateOutput,
      notes = _ref.notes,
      outputId = _ref.outputId,
      onNotesChange = _ref.onNotesChange,
      name = _ref.name,
      updateOutputName = _ref.updateOutputName,
      outputIndex = _ref.outputIndex,
      deleteOutput = _ref.deleteOutput,
      onBlurField = _ref.onBlurField;
  var rotated = ASPECT_RATIO_ROTATE_MAP[aspectRatio].rotated;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "social-iteration"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "social-iteration__preview-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('social-iteration__preview', "social-iteration__preview--".concat(aspectRatio), {
      'social-iteration__preview--rotated': rotated
    })
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
    name: "aspectshell",
    size: 350
  }), /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
    name: "video",
    size: 70,
    color: "white"
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "social-iteration__configure"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "social-iteration__configure__header"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "social-iteration__configure__header__fields"
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Input, {
    label: "Iteration Name",
    placeholder: "Iteration name",
    defaultValue: name || "Iteration ".concat(outputIndex + 1),
    onChange: updateOutputName(outputId),
    disabled: !canUpdateOutput,
    onBlur: onBlurField
  }), /*#__PURE__*/_react.default.createElement(_commonReact.AspectRatio, {
    onChangeAddon: onChangeAddon,
    aspectRatio: aspectRatio,
    disabled: !canUpdateOutput,
    hideLabel: true
  })), /*#__PURE__*/_react.default.createElement(_uiKit.Button, {
    prefix: "trash",
    onClick: deleteOutput,
    type: "TERTIARY",
    disabled: !canUpdateOutput
  })), /*#__PURE__*/_react.default.createElement(_uiKit.Input, {
    disabled: !canUpdateOutput,
    onChange: handleOutputNotesChange(onNotesChange, outputId),
    multiline: true,
    label: "Additional Notes",
    defaultValue: notes,
    className: "social-iteration__configure__notes-text",
    rows: 4,
    onBlur: onBlurField
  })));
}

var _default = /*#__PURE__*/(0, _react.memo)(SocialIteration);

exports.default = _default;